import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { ItemPanel } from '../item-panel/item-panel';
import { Item, SelectionEvent as PanelSelectionEvent } from '../item-panel/item-panel.model';

// The specific interface for this component's data
export interface BrandFilter {
  id: number;
  label: string; // The brand name
  selected?: boolean;
}

// This component's own event payload interface
export interface BrandFilterSelectionEvent {
  source: BrandFilter | null;
  selected: BrandFilter[];
}

@Component({
  selector: 'app-brand-filter-panel',
  imports: [
    ItemPanel
  ],
  templateUrl: './brand-filter-panel.html',
  styleUrl: './brand-filter-panel.scss'
})
export class BrandFilterPanel implements OnInit {
  @Input() title: string = '';
  @Input() brandFilterList: BrandFilter[] = [];
  /** This component's own output, using its own specific event type. */
  @Output() selectionChanged = new EventEmitter<BrandFilterSelectionEvent>();

  // This array is what gets passed to the generic ItemPanel component.
  panelItems: Item[] = [];

  ngOnInit(): void {
    // Maps the detailed BrandFilter data to the generic Item structure needed by the child panel.
    this.panelItems = this.brandFilterList.map(brandFilter => ({
      id: brandFilter.id,
      label: brandFilter.label,
      selected: brandFilter.selected ?? false,
    }));
  }

  /** Handles the generic event from the child panel and maps it to a specific event. */
  onPanelSelectionChange(panelEvent: PanelSelectionEvent): void {
    // 1. Find the full records for all selected items
    const selectedIds = new Set(panelEvent.selectedItems.map(item => item.id));
    const selectedFilters = this.brandFilterList.filter(brandFilter =>
      selectedIds.has(brandFilter.id)
    );

    // 2. Find the full record for the source item that was toggled
    const sourceFilter = panelEvent.source
      ? this.brandFilterList.find(p => p.id === panelEvent.source?.id) ?? null
      : null;

    // 3. Construct and emit this component's own, specific event payload
    this.selectionChanged.emit({
      source: sourceFilter,
      selected: selectedFilters,
    });
  }
}
